import { render, staticRenderFns } from "./aiAdminModels.vue?vue&type=template&id=25d44626&scoped=true"
import script from "./aiAdminModels.vue?vue&type=script&lang=js"
export * from "./aiAdminModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d44626",
  null
  
)

export default component.exports